import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoRevisionCreateComponent } from '../tipo-revision-create/tipo-revision-create.component';
import { TipoRevisionService } from '../tipo-revision.service';
import { TipoRevisionUpdateComponent } from '../tipo-revision-update/tipo-revision-update.component';
import { TipoRevisionViewComponent } from '../tipo-revision-view/tipo-revision-view.component';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Component({
  selector: 'app-tipo-revision-index',
  templateUrl: './tipo-revision-index.component.html',
  styleUrls: ['./tipo-revision-index.component.scss']
})
export class TipoRevisionIndexComponent implements OnInit {

  reloadEmitter: EventEmitter<void> = new EventEmitter();

  columns: any[] = [
    {
      label: 'Nombre',
      attribute: 'nombre'
    },
    {
      label: 'Decripción',
      attribute: 'descripcion'
    },
    {
      label: 'Estado',
      styled: true,
      attribute: 'estado',
      value: (element: any) => {
        if (element.estado == 1) {
          return '<h5><span class="badge bg-primary">Activo</span></h5>';
        } else {
          return '<h5><span class="badge bg-secondary">Inactivo</span></h5>';
        }
      }
    }
  ];
  filters: any[] = [
    {
      label: 'Nombre',
      column: 'nombre',
      op: 'substring',
      type: 'text'
    },
    {
      label: 'Estado',
      column: 'estado',
      op: 'eq',
      type: 'select',
      options: [
        {
          label: "Activo",
          value: 1
        },
        {
          label: "Inactivo",
          value: 0
        },
      ]
    }
  ];
  actions: any[] = [
    {
      icon: "eye",
      label: "Detalles",
      action: (element: any, index: number) => {
        this.view(element);
      }
    }, {
      icon: "pen",
      label: "Editar",
      action: (element: any, index: number) => {
        this.edit(element, index);
      }
    }, {
      icon: "toggle-on",
      label: "Desactivar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == -1
      }
    }, {
      icon: "toggle-off",
      label: "Activar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 1
      }
    }
  ]

  constructor(
    private modalService: NgbModal,
    private service: TipoRevisionService,
    private alerts: AlertService,
    private loading: LoadingService,
    public formatter: FormatterService,
    public config: ConfigService,
    public sesion: SesionService,
  ) { }

  ngOnInit() {
  }

  loadData() {
    this.reloadEmitter.emit();
  }

  agregar(): void {
    const modalRef = this.modalService.open(TipoRevisionCreateComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.result.then((result) => {
      this.loadData();
    }, (reason) => { });
  }

  edit(element: any, index: number): void {
    const modalRef = this.modalService.open(TipoRevisionUpdateComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result) => {
      this.loadData();
    }, (reason) => { });
  }

  view(element: any): void {
    const modalRef = this.modalService.open(TipoRevisionViewComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result) => { }, (reason) => { });
  }

  toggle(element: any): void {
    if (element.estado == 1) {
      this.loading.show();
      this.service.deactivate(element.id).subscribe({
        next: (res) => {
          this.alerts.addAlert("Se ha desactivado el concepto.", "success");
          this.loading.hide();
          this.loadData();
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido desactivar el concepto.", "danger");
        }
      });
    } else {
      this.loading.show();
      this.service.activate(element.id).subscribe({
        next: (res) => {
          this.loading.hide();
          this.alerts.addAlert("Se ha activado el concepto.", "success");
          this.loadData();
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido activar el concepto.", "danger");
        }
      });
    }
  }
}
